import logEvent from 'analytics/logEvent';
import React from 'react';

import pagesUrls from 'constants/pagesUrls';

import Button from 'components/basic/Button';
import Icon, { IconTypes } from 'components/basic/Icon';
import MenuItem from 'components/pagesComponents/landing/Main/components/MobileMenu/MenuItem';
import { menuItems } from 'components/pagesComponents/landing/Main/constants';

import { useAppSelector } from 'redux-store';

import Logo from '../logo.svg';
import Atom from './img/atom.svg';
import Book from './img/book.svg';

import s from './MainMenu.module.scss';

export default function MainMenu(): JSX.Element {
  const { userAgent } = useAppSelector(state => state.ui);
  const profileState = useAppSelector(state => state.profile);
  const { appleOneLinkUrl, googleOneLinkUrl } = useAppSelector(
    state => state.experiments,
  );
  const items = menuItems.map(item => (
    <MenuItem key={item.header} item={item} />
  ));
  const isIOS = userAgent.os.name === 'iOS';

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <Logo className={s.logo} width="120" />
        <a
          onClick={(): void => {
            logEvent('Web_Site_Header_Store_Button_Clicked', {
              type: `${isIOS ? 'appstore' : 'googleplay'}`,
            });
          }}
          className={s.storeLink}
          href={isIOS ? appleOneLinkUrl : googleOneLinkUrl}
        >
          <Icon
            icon={isIOS ? IconTypes.apple : IconTypes.googlePlay}
            size={24}
          />
          <span className="ms-hidden">Get the app</span>
        </a>
      </div>
      <div className={s.categoryHeader}>
        <Atom /> <span>Product</span>
      </div>
      <a
        href="https://welltory.com/plans/"
        className={s.link}
        onClick={(): void => {
          logEvent('Web_Site_Header_Link_Clicked', {
            link_url: 'https://welltory.com/plans/',
          });
        }}
      >
        Plans
      </a>
      <a
        href="https://welltory.com/integrations/"
        className={s.link}
        onClick={(): void => {
          logEvent('Web_Site_Header_Link_Clicked', {
            link_url: 'https://welltory.com/integrations/',
          });
        }}
      >
        Integrations
      </a>
      <a
        href="https://welltory.com/science/"
        className={s.link}
        onClick={(): void => {
          logEvent('Web_Site_Header_Link_Clicked', {
            link_url: 'https://welltory.com/science/',
          });
        }}
      >
        Science
      </a>
      <div className={s.categoryHeader}>
        <Book /> <span>Articles</span>
      </div>
      {items}

      {!profileState.isAuthenticated && (
        <>
          <div className={s.buttonFixer} />
          <div
            className={s.buttonWrapper}
            onClick={(): void => {
              logEvent('Web_Site_Header_Sign-in_Button_Clicked');
            }}
          >
            <Button
              href={`https://app.welltory.com${pagesUrls.auth}`}
              size="medium"
              className={s.button}
            >
              sign in
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
